// Global
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { categoriesSelector } from '../../feature/selectors';

// Components
import CreateCategoryForm from '../../components/CreateCategoryForm/CreateCategoryForm';

// Helpers
import { IFormInstance, showErrorToast, showSuccessToast } from '@/components';
import { CreateCategoryDTO } from '../../dtos';
import { createCategory, getCategories } from '../../feature';
import { CreateCategoryFieldNames } from '../../helpers/types';

type TCreateCategoryContainer = {
  form: IFormInstance;
  onCreate: () => void;
};

const CreateCategoryContainer = ({ form, onCreate }: TCreateCategoryContainer) => {
  const { t } = useTranslation(['categories']);

  const dispatch = useAppDispatch();
  const { categories, isLoadingCategories } = useAppState(categoriesSelector);

  const handleSubmit = useCallback(async () => {
    try {
      const values = form.getFieldsValue();
      const createCategoryDto = new CreateCategoryDTO(values);

      await dispatch(createCategory(createCategoryDto)).unwrap();
      await dispatch(getCategories());

      showSuccessToast({ message: t('create_category_success') });
      onCreate();
    } catch {}
  }, []);

  const onFinishFailed = (error: ValidateErrorEntity) => {
    const missingLangs = error.errorFields.map((f) => f.name[0]);

    if (missingLangs.includes(CreateCategoryFieldNames.LOCALE)) {
      showErrorToast({ message: t('create_category_error_hint') });
    }
  };

  return (
    <CreateCategoryForm
      categories={categories}
      onSubmit={handleSubmit}
      onFinishFailed={onFinishFailed}
      formInstance={form}
      isLoading={isLoadingCategories}
    />
  );
};

export default CreateCategoryContainer;
